import HubspotForm from './HubspotForm';
export default HubspotForm;
